module.exports = __webpack_public_path__ + "static/media/app-icon.713f7b75.png";